module.exports = __webpack_public_path__ + "img/pvlogo.06f03443.png";